// home
import home from './home/index.vue';
import childrenVue from './children.vue';

// account
import accountRouteMap from './account/route';
// customer
import customerRouteMap from './customer/route';
// warehouse
import warehouseRouteMap from './warehouse/route';
// goods
import goodsRouteMap from './goods/route';

export default [
  // home
  {
    name: '工作台',
    path: '/home',
    component: home,
  },
  {
    path: '/goods',
    component: childrenVue,
    children: goodsRouteMap,
  },
  {
    path: '/customer',
    component: childrenVue,
    children: customerRouteMap,
  },
  {
    path: '/warehouse',
    component: childrenVue,
    children: warehouseRouteMap,
  },
  {
    path: '/account',
    component: childrenVue,
    children: accountRouteMap,
  },
];
